module.exports = __webpack_public_path__ + "img/12_of_Diamonds.svg.762847d2.png";